import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { webSocket } from 'rxjs/webSocket';
import { WebSocketEventModel } from '../models/workflow-event';

@Injectable({
  providedIn: 'root',
})
export class WebSocket {
  connect(url: string): Observable<WebSocketEventModel> {
    return webSocket<WebSocketEventModel>(url);
  }
}
